/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Public_Info_MiscommunicationInputs */



/**
* | output |
* | --- |
* | "Public Info Miscommunication" |
*
* @param {Sanction_Sub_Public_Info_MiscommunicationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_public_info_miscommunication = /** @type {((inputs?: Sanction_Sub_Public_Info_MiscommunicationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Public_Info_MiscommunicationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur de Communication d'Info Publique")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error en Comunicación de Info Pública")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Erro de Comunicação de Info Pública")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore di Comunicazione Info Pubbliche")
	return /** @type {LocalizedString} */ ("Public Info Miscommunication")
});